export const initOKXWallet = () => {
    const encodedUrl = "https://www.okx.com/download?deeplink=" + encodeURIComponent("okx://wallet/dapp/url?dappUrl=" + encodeURIComponent(location.href));
    window.location.href = encodedUrl;
}